import { render, staticRenderFns } from "./DistributionOfOtherOverheadsChart.vue?vue&type=template&id=4996c01a"
import script from "./DistributionOfOtherOverheadsChart.vue?vue&type=script&lang=js"
export * from "./DistributionOfOtherOverheadsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports